<div class="report-viewer-container" [style.height]="height" [style.width]="width">
  <!-- Toolbar -->
  <div *ngIf="showToolbar" class="report-toolbar">
    <div class="toolbar-left">
      <mat-icon svgIcon="analytics" class="toolbar-icon"></mat-icon>
      <span class="toolbar-title">{{ reportName }}</span>
    </div>
    <div class="toolbar-actions">
      <!-- Report Link -->
      <a
        *ngIf="showLink"
        [href]="reportLink"
        target="_blank"
        rel="noopener noreferrer"
        class="report-link"
        matTooltip="Open in Power BI"
      >
        <mat-icon svgIcon="open_in_new"></mat-icon>
        <span class="link-text">Open in Power BI</span>
      </a>
      <button
        mat-icon-button
        matTooltip="Refresh Report"
        (click)="refresh()"
        [disabled]="isLoading"
        class="toolbar-button"
      >
        <mat-icon svgIcon="refresh"></mat-icon>
      </button>
      <button
        mat-icon-button
        matTooltip="Open in New Tab"
        (click)="openInNewTab()"
        class="toolbar-button"
      >
        <mat-icon svgIcon="open_in_new"></mat-icon>
      </button>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="report-loading">
    <mat-spinner diameter="60"></mat-spinner>
    <p class="loading-text">Loading Power BI Report...</p>
    <p class="loading-subtext">You may be prompted to sign in with your Microsoft account</p>
  </div>

  <!-- Error State -->
  <div *ngIf="hasError" class="report-error">
    <mat-icon svgIcon="error_outline" class="error-icon"></mat-icon>
    <h3>Failed to Load Report</h3>
    <p>{{ errorMessage }}</p>
    <div class="error-actions">
      <button mat-raised-button color="primary" (click)="reload()">
        <mat-icon svgIcon="refresh"></mat-icon>
        Retry
      </button>
      <button mat-stroked-button color="primary" (click)="openInNewTab()">
        <mat-icon svgIcon="open_in_new"></mat-icon>
        Open in Power BI
      </button>
    </div>
  </div>

  <!-- Report iframe Container -->
  <div class="report-frame-container" [class.hidden]="hasError">
    <iframe
      *ngIf="embedUrl"
      [src]="embedUrl"
      class="report-iframe"
      frameborder="0"
      allowfullscreen="true"
      (load)="onIframeLoad()"
      (error)="onIframeError()"
    ></iframe>
  </div>
</div>
